export default __webpack_public_path__ + "static/media/directory-story.e2275dbf.jpg";